import { useMutation } from "@tanstack/react-query";
import systemPreferencesService from "../api/systemPreferencesService";

export const useUpdateSystemPreferences = () => {
  const { updateSystemPreferences } = systemPreferencesService();

  return useMutation({
    mutationKey: ["update-system-preferences"],
    mutationFn: async ({ systemPreferences }) => {
      const response = await updateSystemPreferences(systemPreferences);
      return response.data;
    },
  });
};
